import QueryString from "qs";
import { OrganizationPublicId } from "../service/server/Types";

// TODO: Use a real parser here
const rep = (original: string, params: Record<string, string>) => {
  return original
    .replace(":orgId", params.orgId)
    .replace(":organizationId", params.organizationId)
    .replace(":collectionGroupId", params.collectionGroupId)
    .replace(":picId", params.picId)
    .replace(":picGroupId", params.picGroupId)
    .replace(":user", params.user)
    .replace(":email", params.email)
    .replace(":requestId", params.requestId)
    .replace(":jobId", params.jobId)
    .replace(":attachmentId", params.attachmentId)
    .replace(":vendorId", params.vendorId)
    .replace(":vendorKey", params.vendorKey)
    .replace(":platformId", params.platformId)
    .replace(":appId", params.appId)
    .replace(":id", params.id)
    .replace(":mailbox", params.mailbox)
    .replace(":privacyCenterId", params.privacyCenterId)
    .replace(":sectionId", params.sectionId)
    .replace(":dataSubjectTypeId", params.dataSubjectTypeId)
    .replace(":consumerGroupId", params.consumerGroupId)
    .replace(":dataRequestTypeId", params.dataRequestTypeId)
    .replace(":regulationSlug", params.regulationSlug)
    .replace(":progressStep", params.progressStep)
    .replace(":invalidatedProgressStep", params.invalidatedProgressStep)
    .replace(":mappingProgress", params.mappingProgress)
    .replace(":personalInformationType", params.personalInformationType)
    .replace(":categoryId", params.categoryId)
    .replace(":category", params.category)
    .replace(":sourceId", params.sourceId)
    .replace(":sourceName", params.sourceName)
    .replace(":purposeId", params.purposeId)
    .replace(":surveyName", params.surveyName)
    .replace(":privacyNoticeProgress", params.privacyNoticeProgress)
    .replace(":requestHandlingInstructionId", params.requestHandlingInstructionId)
    .replace(":domain", params.domain)
    .replace(":name", params.name)
    .replace(":requestHandlingInstructionType", params.requestHandlingInstructionType)
    .replace(":fileKey", params.fileKey)
    .replace(":slug", params.slug)
    .replace(":consumerId", params.consumerId)
    .replace(":taskId", params.taskId)
    .replace(":tokenId", params.tokenId)
    .replace(":type", params.type)
    .replace(":dpaId", params.dpaId)
    .replace(":ropaId", params.ropaId)
    .replace(":dpaApprovalPartyId", params.dpaApprovalPartyId)
    .replace(":dpaAnswerId", params.dpaAnswerId)
    .replace(":sectionId", params.sectionId)
    .replace(":noticeId", params.noticeId)
    .replace(":trackerId", params.trackerId)
    .replace(":managerId", params.managerId)
    .replace(":networkId", params.networkId)
    .replace(":managedAdNetworkId", params.managedAdNetworkId)
    .replace(":rebake", params.rebake)
    .replace(":conversationId", params.conversationId)
    .replace(":messageId", params.messageId)
    .replace(":fileId", params.fileId);
};

export const ApiRoutes = {
  public: {
    orgNotices: "/api/public/org/:orgId/notices",
    orgDomainSetupInstructions: "/api/public/org/:orgId/domain-setup-instructions",
  },
  user: {
    self: "/api/users/self",
    allUserOrgPreferences: "/api/users/self/allUserOrgPreferences",
    acknowledgeWelcome: "/api/users/acknowledgeWelcome",
    session: "/api/users/self/session",
    activeOrganization: "/api/users/self/activeOrganization",
    login: "/api/login",
    logout: "/api/logout",
    activate: "/api/users/:user/activate/:organizationId",
    forgotPassword: "/api/users/forgotPassword",
    orgPreferences: "/api/users/self/:organizationId/preferences",
  },
  mfa: {
    root: "/api/mfa",
    validate: "/api/mfa/validate",
  },
  vendors: {
    root: "/api/vendors",
    specific: "/api/vendors/:vendorId",
  },
  processingActivities: {
    root: "/api/processingActivities",
  },
  retentionReasons: {
    root: "/api/retentionReasons",
  },
  dataMap: {
    recommendedCollection: "/api/dataMap/recommendedCollection",
  },
  marketingWebsiteContent: {
    root: "/api/marketingWebsiteContent",
  },
  regulation: {
    requestTypes: "/api/regulation/requestTypes",
  },
  organization: {
    root: "/api/organizations/:organizationId",
    gaWebProperty: "/api/organizations/:organizationId/gaWebProperty",
    getCompliantDone: "/api/organizations/:organizationId/getCompliantDone",
    jwt: "/api/organizations/:organizationId/jwt",
    eventPulseLaunch: "/api/organizations/:organizationId/eventPulse/launch",
    mcpTokens: {
      root: "/api/organizations/:organizationId/mcpTokens",
      specific: "/api/organizations/:organizationId/mcpTokens/:tokenId",
      extend: "/api/organizations/:organizationId/mcpTokens/:tokenId/extend",
    },
    childOrgs: "/api/organizations/:organizationId/childOrgs",
    processingActivities: {
      root: "/api/organizations/:organizationId/processingActivities",
      automatic: "/api/organizations/:organizationId/processingActivities/automatic",
      specific: "/api/organizations/:organizationId/processingActivities/:id",
      specificAssociationPic:
        "/api/organizations/:organizationId/processingActivities/:id/association/:picId",
    },
    collectionGroups: {
      root: "/api/organizations/:organizationId/collectionGroups",
      default: "/api/organizations/:organizationId/collectionGroups/default",
      consumer: "/api/organizations/:organizationId/collectionGroups/consumer",
      specific: "/api/organizations/:organizationId/collectionGroups/:dataSubjectTypeId",
      defaultRecipientAssociations:
        "/api/organizations/:organizationId/collectionGroups/:dataSubjectTypeId/defaultRecipientAssociations",
      mappingProgress:
        "/api/organizations/:organizationId/collectionGroups/:dataSubjectTypeId/mappingProgress/:personalInformationType/:mappingProgress",
      vendor: {
        specific:
          "/api/organizations/:organizationId/collectionGroups/:dataSubjectTypeId/vendors/:vendorId",
        mappingProgress:
          "/api/organizations/:organizationId/collectionGroups/:dataSubjectTypeId/vendors/mappingProgress",
      },
      privacyNoticeProgress:
        "/api/organizations/:organizationId/collectionGroups/:dataSubjectTypeId/privacyNoticeProgress/:privacyNoticeProgress",
      publishEmployeeGroupHrDataRetentionPolicies:
        "/api/organizations/:organizationId/collectionGroups/publishEmployeeGroupHrDataRetentionPolicies",
      getArchivedHrDataRetentionPolicies:
        "/api/organizations/:organizationId/collectionGroups/archivedHrDataRetentionPolicies",
      downloadArchivedHrDataRetentionPolicyPdf:
        "/api/organizations/:organizationId/collectionGroups/downloadArchivedHrDataRetentionPolicyPdf",
    },
    createChargebeePortal: "/api/organizations/:organizationId/createPortalSession",
    getChargebeeCustomerInfo: "/api/organizations/:organizationId/getChargebeeCustomer",
    dataRetention: {
      root: "/api/organizations/:organizationId/dataRetention",
      automatic: "/api/organizations/:organizationId/dataRetention/automatic",
      category: "/api/organizations/:organizationId/dataRetention/:id",
    },
    dataMap: {
      root: "/api/organizations/:organizationId/dataMap",
      picCollection:
        "/api/organizations/:organizationId/dataMap/collectionGroup/:collectionGroupId/collection/:picId",
      picAssociation:
        "/api/organizations/:organizationId/dataMap/collectionGroup/:collectionGroupId/association/:vendorId",
      picSourceAssociation:
        "/api/organizations/:organizationId/dataMap/collectionGroup/:collectionGroupId/sourceAssociation/:vendorId",
      picDisclosure:
        "/api/organizations/:organizationId/dataMap/collectionGroup/:collectionGroupId/disclosure/:vendorId/:picGroupId",
      picReceived:
        "/api/organizations/:organizationId/dataMap/collectionGroup/:collectionGroupId/received/:vendorId/:picGroupId",
    },
    dataInventory: {
      snapshot: "/api/organizations/:organizationId/dataInventory/snapshot",
      collection: {
        root: "/api/organizations/:organizationId/dataInventory/collection",
        default: "/api/organizations/:organizationId/dataInventory/collection/default",
        batch: "/api/organizations/:organizationId/dataInventory/collection/:dataSubjectTypeId",
        clearInternallyStored:
          "/api/organizations/:organizationId/dataInventory/collection/:dataSubjectTypeId/category/internallyStored",
        specificCategory:
          "/api/organizations/:organizationId/dataInventory/collection/:dataSubjectTypeId/category/:categoryId",
        specificSource:
          "/api/organizations/:organizationId/dataInventory/collection/:dataSubjectTypeId/source/:sourceId",
        customSource:
          "/api/organizations/:organizationId/dataInventory/collection/:dataSubjectTypeId/customSource/:sourceName",
        specificPurpose:
          "/api/organizations/:organizationId/dataInventory/collection/:dataSubjectTypeId/purpose/:purposeId",
      },
      exchange: {
        root: "/api/organizations/:organizationId/dataInventory/exchange",
        specificConsumerGroup:
          "/api/organizations/:organizationId/dataInventory/exchange/consumerGroup/:consumerGroupId",
        specificVendor:
          "/api/organizations/:organizationId/dataInventory/exchange/vendor/:vendorId",
      },
    },
    documents: {
      dataProtectionAssessments: {
        root: "/api/organizations/:organizationId/documents/dpa",
        suggested: "/api/organizations/:organizationId/documents/dpa/suggested",
        specific: "/api/organizations/:organizationId/documents/dpa/:dpaId",
        unsignedPdf: "/api/organizations/:organizationId/documents/dpa/:dpaId/unsignedPdf",
        signedPdf: "/api/organizations/:organizationId/documents/dpa/:dpaId/signedPdf",
        uploadUnsignedPdf:
          "/api/organizations/:organizationId/documents/dpa/:dpaId/uploadUnsignedPdf",
        uploadPreSignedPdf:
          "/api/organizations/:organizationId/documents/dpa/:dpaId/uploadPreSignedPdf",
        prompts: "/api/organizations/:organizationId/documents/dpa/prompts",
        abandon: "/api/organizations/:organizationId/documents/dpa/:dpaId/abandon",
        answers: {
          root: "/api/organizations/:organizationId/documents/dpa/:dpaId/answers",
          specific: "/api/organizations/:organizationId/documents/dpa/:dpaId/answers/:dpaAnswerId",
        },
        finalizeSignatures:
          "/api/organizations/:organizationId/documents/dpa/:dpaId/finalizeSignatures",
        cancelSignatureRequest:
          "/api/organizations/:organizationId/documents/dpa/:dpaId/cancelSignatureRequest",
        approvalParties: {
          root: "/api/organizations/:organizationId/documents/dpa/:dpaId/approvalParties",
          specific:
            "/api/organizations/:organizationId/documents/dpa/:dpaId/approvalParties/:dpaApprovalPartyId",
        },
      },
      ropa: {
        root: "/api/organizations/:organizationId/documents/ropa",
        summary: "/api/organizations/:organizationId/documents/ropa/summary",
        details: "/api/organizations/:organizationId/documents/ropa/details",
        history: "/api/organizations/:organizationId/documents/ropa/history",
        delete: "/api/organizations/:organizationId/documents/ropa/:ropaId/delete",
        download: "/api/organizations/:organizationId/documents/ropa/:ropaId/download",
        saveLatestVersion: "/api/organizations/:organizationId/documents/ropa/saveLatestVersion",
        setMeasures: "/api/organizations/:organizationId/documents/ropa/setMeasures",
      },
      auditLog: "/api/organizations/:organizationId/documents/auditLog",
    },
    files: {
      root: "/api/organizations/:organizationId/files",
      specific: "/api/organizations/:organizationId/files/:fileId",
      download: "/api/organizations/:organizationId/files/:fileId/download",
    },
    templates: "/api/organizations/:organizationId/templates",
    mailboxes: "/api/organizations/:organizationId/mailboxes",
    sendMethod: "/api/organizations/:organizationId/sendMethod",
    postmarkMailbox: "/api/organizations/:organizationId/postmark",
    postmarkMailboxShare: "/api/organizations/:organizationId/postmark/share",
    postmarkMailboxShareOptions: "/api/organizations/:organizationId/postmark/share/options",
    postmarkMailboxVerify: "/api/organizations/:organizationId/postmark/verify",
    postmarkMailboxTest: "/api/organizations/:organizationId/postmark/test",
    postmarkInbox: {
      conversations: "/api/organizations/:organizationId/postmark/inbox/conversations",
      conversation:
        "/api/organizations/:organizationId/postmark/inbox/conversations/:conversationId",
      reply:
        "/api/organizations/:organizationId/postmark/inbox/conversations/:conversationId/reply",
      archive:
        "/api/organizations/:organizationId/postmark/inbox/conversations/:conversationId/archive",
      unarchive:
        "/api/organizations/:organizationId/postmark/inbox/conversations/:conversationId/unarchive",
      markRead:
        "/api/organizations/:organizationId/postmark/inbox/conversations/:conversationId/mark-read",
      markUnread:
        "/api/organizations/:organizationId/postmark/inbox/conversations/:conversationId/mark-unread",
      createDsr:
        "/api/organizations/:organizationId/postmark/inbox/conversations/:conversationId/create-dsr",
      bulk: "/api/organizations/:organizationId/postmark/inbox/conversations/bulk",
      attachment:
        "/api/organizations/:organizationId/postmark/inbox/messages/:messageId/attachments/:attachmentId",
    },
    onboardingProgress: "/api/organizations/:organizationId/onboardingProgress",
    mailbox: "/api/organizations/:organizationId/mailboxes/:mailbox",
    dataRequestTypes: "/api/organizations/:organizationId/dataRequestTypes",
    features: "/api/organizations/:organizationId/features",
    survey: "/api/organizations/:organizationId/survey/:surveyName",
    surveySend: "/api/organizations/:organizationId/survey/:surveyName/send",
    complianceChecklist: "/api/organizations/:organizationId/complianceChecklist",
    customMessageType: {
      list: "/api/organizations/:organizationId/templates",
      specific: "/api/organizations/:organizationId/templates/:slug",
    },
    messageSettings: "/api/organizations/:organizationId/messageSettings",
    customField: "/api/organizations/:organizationId/customField",
    customOptOutField: "/api/organizations/:organizationId/customOptOutField",
    financialIncentives: "/api/organizations/:organizationId/financialIncentives",
    verificationInstruction: "/api/organizations/:organizationId/verificationInstruction",
    testMessage: "/api/organizations/:organizationId/messageSettings/test",
    admin: {
      users: "/api/organizations/:organizationId/admin/users",
      specificUser: "/api/organizations/:organizationId/admin/users/:email",
      activateUser: "/api/organizations/:organizationId/admin/users/:email/activate",
      deactivateUser: "/api/organizations/:organizationId/admin/users/:email/deactivate",
      inviteUser: "/api/organizations/:organizationId/admin/users/invite",
      assignUserRole: "/api/organizations/:organizationId/admin/users/:email/assignRole",
    },
    dataSources: {
      root: "/api/organizations/:organizationId/dataSources",
      specific: "/api/organizations/:organizationId/dataSources/:id",
    },
    privacyCenters: "/api/organizations/:organizationId/privacyCenters",
    privacyCenter: {
      detail: "/api/organizations/:organizationId/privacyCenters/:privacyCenterId",
      verifyDomain:
        "/api/organizations/:organizationId/privacyCenters/:privacyCenterId/verify?domain=:domain",
      domain: "/api/organizations/:organizationId/privacyCenters/:privacyCenterId/domain",
      deleteImage: "/api/organizations/:organizationId/privacyCenters/:privacyCenterId/deleteImage",
      privacyPolicy: {
        policy: "/api/organizations/:organizationId/privacyCenters/:privacyCenterId/policy",
        sections:
          "/api/organizations/:organizationId/privacyCenters/:privacyCenterId/policy/sections",
        sectionDetail:
          "/api/organizations/:organizationId/privacyCenters/:privacyCenterId/policy/sections/:sectionId",
      },
      fonts: "/api/organizations/:organizationId/privacyCenters/:privacyCenterId/fonts",
      cmpCustomization:
        "/api/organizations/:organizationId/privacyCenters/:privacyCenterId/cmpCustomization",
      cmpCustomizationStaging:
        "/api/organizations/:organizationId/privacyCenters/:privacyCenterId/cmpCustomization/staging",
      updateGAMeasurementId:
        "/api/organizations/:organizationId/privacyCenters/:privacyCenterId/updateGAMeasurementId",
      notices: {
        root: "/api/organizations/:organizationId/privacyCenters/:privacyCenterId/notices",
        specificNotice:
          "/api/organizations/:organizationId/privacyCenters/:privacyCenterId/notices/:noticeId",
        noticeEditorMetadata:
          "/api/organizations/:organizationId/privacyCenters/:privacyCenterId/editorMetadata",
        stateSectionVisibility:
          "/api/organizations/:organizationId/privacyCenters/:privacyCenterId/notices/:noticeId/stateSectionVisibility",
        createEditableStateSection:
          "/api/organizations/:organizationId/privacyCenters/:privacyCenterId/notices/:noticeId/createEditableStateSection",
        removeEditableStateSection:
          "/api/organizations/:organizationId/privacyCenters/:privacyCenterId/notices/:noticeId/removeEditableStateSection",
        downloadStateSectionContent:
          "/api/organizations/:organizationId/privacyCenters/:privacyCenterId/notices/:noticeId/downloadStateSectionContent",
        noticePdf:
          "/api/organizations/:organizationId/privacyCenters/:privacyCenterId/notices/:noticeId/pdf",
        noticeHtml:
          "/api/organizations/:organizationId/privacyCenters/:privacyCenterId/notices/:noticeId/html",
        archiveColoradoEmployeeBiometricNoticePdf:
          "/api/organizations/:organizationId/privacyCenters/:privacyCenterId/notices/:noticeId/archiveColoradoEmployeeBiometricNoticePdf",
        redlinesDiff:
          "/api/organizations/:organizationId/privacyCenters/:privacyCenterId/notices/redlines/diff",
        sections: {
          root: "/api/organizations/:organizationId/privacyCenters/:privacyCenterId/notices/:noticeId/sections",
          specificSection:
            "/api/organizations/:organizationId/privacyCenters/:privacyCenterId/notices/:noticeId/sections/:sectionId",
        },
      },
      integrations:
        "/api/organizations/:organizationId/privacyCenters/:privacyCenterId/integrations",
      availableIntegrationVendorIds:
        "/api/organizations/:organizationId/privacyCenters/:privacyCenterId/availableIntegrationVendorIds",
      consentRecords:
        "/api/organizations/:organizationId/privacyCenters/:privacyCenterId/consentRecords",
      consentRecordsStats:
        "/api/organizations/:organizationId/privacyCenters/:privacyCenterId/consentRecords/stats",
      consumerConsentLookup:
        "/api/organizations/:organizationId/privacyCenters/:privacyCenterId/consumerConsentLookup",
    },
    websiteAudit: {
      root: "/api/organizations/:organizationId/websiteAudit",
      reset: "/api/organizations/:organizationId/websiteAudit/reset",
    },
    trueScan: {
      root: "/api/organizations/:organizationId/trueScan?rebake=:rebake",
      scan: "/api/organizations/:organizationId/trueScan/scan",
      onboardingVendorScan: "/api/organizations/:organizationId/trueScan/onboarding-vendor-scan",
      hasEverScanned: "/api/organizations/:organizationId/trueScan/has-ever-scanned",
      tracker: "/api/organizations/:organizationId/trueScan/tracker/:trackerId",
      trackerBulkUpdate: "/api/organizations/:organizationId/trueScan/tracker/bulk-update",
      csv: "/api/organizations/:organizationId/trueScan.csv",
    },
    ramsay: {
      messages: "/api/organizations/:organizationId/ramsay/messages",
      warm: "/api/organizations/:organizationId/ramsay/warm",
      serviceAccountInbox: "/api/organizations/:organizationId/ramsay/service-account-inbox",
      serviceAccounts: "/api/organizations/:organizationId/ramsay/service-accounts",
    },
    cookieScanner: {
      root: "/api/organizations/:organizationId/cookieScanner",
      createCookie: "/api/organizations/:organizationId/cookieScanner/cookie",
      cookie: "/api/organizations/:organizationId/cookieScanner/cookie/:domain/:name",
      cookieRecommendations: "/api/organizations/:organizationId/cookieScanner/recommendations",
    },
    cookieConsent: {
      root: "/api/organizations/:organizationId/cookieConsent",
    },
    authorization: {
      authorizations: "/api/organizations/:organizationId/authorizations",
      google: "/api/organizations/:organizationId/authorize/google",
    },
    request: {
      root: "/api/organizations/:organizationId/requests",
      gpcOptOuts: "/api/organizations/:organizationId/requests/gpcOptOuts",
      gpcOptOutsCsv: "/api/organizations/:organizationId/requests/gpcOptOuts/csv",
      stats: "/api/organizations/:organizationId/requests/stats",
      specific: "/api/organizations/:organizationId/requests/:requestId",
      templates: {
        closed: "/api/organizations/:organizationId/requests/:requestId/templates/closed",
        contactVendor:
          "/api/organizations/:organizationId/requests/:requestId/templates/contactVendor",
        contactVendorPreview:
          "/api/organizations/:organizationId/requests/contactVendorPreviewTemplate/:type",
      },
      autodelete: {
        googleAnalytics:
          "/api/organizations/:organizationId/requests/:requestId/autodelete/googleAnalytics",
      },
      state: "/api/organizations/:organizationId/requests/:requestId/state",
      vendor: "/api/organizations/:organizationId/requests/:requestId/vendor",
      contactVendors: "/api/organizations/:organizationId/requests/:requestId/contactVendors",
      contactRequestor: "/api/organizations/:organizationId/requests/:requestId/contactRequestor",
      verify: "/api/organizations/:organizationId/requests/:requestId/verify",
      note: "/api/organizations/:organizationId/requests/:requestId/note",
      reply: "/api/organizations/:organizationId/requests/:requestId/reply",
      reopen: "/api/organizations/:organizationId/requests/:requestId/reopen",
      stepConsumerGroup:
        "/api/organizations/:organizationId/requests/:requestId/step/consumerGroup",
      setSubjectStatus: "/api/organizations/:organizationId/requests/:requestId/subjectStatus",
      stepForward: "/api/organizations/:organizationId/requests/:requestId/step/forward",
      stepBack: "/api/organizations/:organizationId/requests/:requestId/step/back",
      manuallyAutomate: "/api/organizations/:organizationId/requests/:requestId/manuallyAutomate",
      extend: "/api/organizations/:organizationId/requests/:requestId/extend",
      dataRequestAttachments: "/api/organizations/:organizationId/requests/:requestId/attachments",
      dataRequestAttachmentSpecific:
        "/api/organizations/:organizationId/requests/:requestId/attachments/:attachmentId",
    },
    exports: {
      root: "/api/organizations/:organizationId/exports",
      specific: "/api/organizations/:organizationId/exports/:jobId",
    },
    requestBatch: {
      root: "/api/organizations/:organizationId/requestBatch",
      specific: "/api/organizations/:organizationId/requestBatch/:requestBatchId",

      create: "/api/organizations/:organizationId/requestBatch/create",
      delete: "/api/organizations/:organizationId/requestBatch/delete",
    },
    consumer: {
      requests: "/api/organizations/:organizationId/requests/consumer",
      export: "/api/organizations/:organizationId/requests/export",
    },
    task: {
      root: "/api/organizations/:organizationId/tasks",
      completeTasks: "/api/organizations/:organizationId/tasks/complete",
      completeTask: "/api/organizations/:organizationId/tasks/:taskId/complete",
      addDpo: "/api/organizations/:organizationId/tasks/addDpo",
      addAuthorizeGoogleAnalytics:
        "/api/organizations/:organizationId/tasks/authorizeGoogleAnalytics",
      completeFinIncentives: "/api/organizations/:organizationId/tasks/completeFinancialIncentives",
      addEeaDesignatedRep: "/api/organizations/:organizationId/tasks/addDesignatedRep",
    },
    requestHandlingInstructions: {
      root: "/api/organizations/:organizationId/requestHandling",
      forType: "/api/organizations/:organizationId/requestHandling/:requestHandlingInstructionType",
      consumerGroup: "/api/organizations/:organizationId/requestHandling/cgInstructions",
      optOut: "/api/organizations/:organizationId/requestHandling/optOutInstructions",
      profilingOptOut:
        "/api/organizations/:organizationId/requestHandling/profilingOptOutInstructions",
      appeal: "/api/organizations/:organizationId/requestHandling/appealInstructions",
      correction: "/api/organizations/:organizationId/requestHandling/correctionInstructions",
      progress: "/api/organizations/:organizationId/requestHandling/mappingProgress",
      instruction:
        "/api/organizations/:organizationId/requestHandling/:requestHandlingInstructionId",
    },
    dataRecipients: {
      root: "/api/organizations/:organizationId/dataRecipients",
      specific: "/api/organizations/:organizationId/dataRecipients/:vendorId",
    },
    vendor: {
      commonCatalog: "/api/organizations/:organizationId/vendors/commonCatalog",
      customCatalog: "/api/organizations/:organizationId/vendors/customCatalog",
      root: "/api/organizations/:organizationId/vendors",
      unmapped: "/api/organizations/:organizationId/vendors/unmapped/:collectionGroupId",
      remove: "/api/organizations/:organizationId/vendors/remove",
      default: "/api/organizations/:organizationId/vendors/default",
      thirdPartyRecipients: "/api/organizations/:organizationId/vendors/thirdPartyRecipients",
      new: "/api/organizations/:organizationId/vendors/new",
      search: "/api/organizations/:organizationId/vendors/search",
      migrateYotpo: "/api/organizations/:organizationId/vendors/migrateYotpo",
      specific: "/api/organizations/:organizationId/vendors/:vendorId",
      platformApps: "/api/organizations/:organizationId/recipientPlatforms/:vendorId/apps",
      platformAppsByVendorKey:
        "/api/organizations/:organizationId/recipientPlatforms/vendorKey/:vendorKey/apps",
      appPlatforms: "/api/organizations/:organizationId/recipientPlatforms/:vendorId/platforms",
      appInstall: "/api/organizations/:organizationId/recipientPlatforms/:platformId/apps/:appId",
      add: "/api/organizations/:organizationId/vendors/:vendorId/new",
      edit: "/api/organizations/:organizationId/vendors/:vendorId/edit",
      agreement: "/api/organizations/:organizationId/vendors/:vendorId/agreement",
      automationHistory: "/api/organizations/:organizationId/vendors/automationHistory",
      mappingProgress:
        "/api/organizations/:organizationId/vendors/:vendorId/mappingProgress/:mappingProgress",
      requestDocumentation: "/api/organizations/:organizationId/vendors/requestDocumentation",
      requestVendorDocumentationBulk:
        "/api/organizations/:organizationId/vendors/requestVendorDocumentationBulk",
      requestVendorServiceProviderInfo:
        "/api/organizations/:organizationId/vendors/requestVendorServiceProviderInfo",
      requestGdprProcessorStatusInfo:
        "/api/organizations/:organizationId/vendors/requestGdprProcessorStatusInfo",
    },
    privacyNotice: {
      ca: "/api/organizations/:organizationId/privacyNotices/ca",
      optOut: "/api/organizations/:organizationId/privacyNotices/optOut",
      consumerGroup:
        "/api/organizations/:organizationId/privacyNotices/consumerGroup/:consumerGroupId",
    },
    categories: {
      root: "/api/organizations/:organizationId/categories",
      specific: "/api/organizations/:organizationId/categories/:categoryId",
    },
    managedAdNetworks: {
      root: "/api/organizations/:organizationId/managed-ad-networks",
      byManager: "/api/organizations/:organizationId/managed-ad-networks/manager/:managerId",
      byNetwork: "/api/organizations/:organizationId/managed-ad-networks/network/:networkId",
      specific: "/api/organizations/:organizationId/managed-ad-networks/:managedAdNetworkId",
      byManagerAndNetwork:
        "/api/organizations/:organizationId/managed-ad-networks/manager/:managerId/network/:networkId",
      dataRetrievedVia: "/api/organizations/:organizationId/managed-ad-networks/data-retrieved-via",
      dataRetrievedViaByNetwork:
        "/api/organizations/:organizationId/managed-ad-networks/data-retrieved-via/network/:networkId",
    },
  },
  storage: {
    logos: {
      organization: "/api/storage/logos/organization/:organizationId",
      privacyCenter:
        "/api/storage/logos/organization/:organizationId/privacyCenter/:privacyCenterId",
    },
    fonts: {
      privacyCenter:
        "/api/storage/fonts/organization/:organizationId/privacyCenter/:privacyCenterId",
    },
    vendorAgreements: {
      root: "/api/storage/vendoragreements/organization/:organizationId/vendor/:vendorId",
      specific:
        "/api/storage/vendoragreements/organization/:organizationId/vendor/:vendorId/:fileKey",
      byType:
        "/api/storage/vendoragreements/organization/:organizationId/vendor/:vendorId/?type=:type",
    },
  },
};

export const formatUrl = (base: string, params: any, encode: boolean = true) => {
  const join = base.includes("?") ? "&" : "?";
  return `${base}${join}${QueryString.stringify(params, { encode })}`;
};

export const ApiRouteHelpers = {
  public: {
    orgNotices: (orgId) => rep("/api/public/org/:orgId/notices", { orgId }),
    orgDomainSetupInstructions: (orgId) =>
      rep(ApiRoutes.public.orgDomainSetupInstructions, { orgId }),
  },
  user: {
    activate: (user, organizationId) => rep(ApiRoutes.user.activate, { user, organizationId }),
    orgPreferences: (organizationId) => rep(ApiRoutes.user.orgPreferences, { organizationId }),
  },
  regulation: {
    requestTypes: () => ApiRoutes.regulation.requestTypes,
  },
  organization: {
    root: (organizationId) => rep(ApiRoutes.organization.root, { organizationId }),
    gaWebProperty: (organizationId) =>
      rep(ApiRoutes.organization.gaWebProperty, { organizationId }),
    templates: (organizationId) => rep(ApiRoutes.organization.templates, { organizationId }),
    mailboxes: (organizationId) => rep(ApiRoutes.organization.mailboxes, { organizationId }),
    sendMethod: (organizationId) => rep(ApiRoutes.organization.sendMethod, { organizationId }),
    mailbox: (organizationId, mailbox) =>
      rep(ApiRoutes.organization.mailbox, { organizationId, mailbox }),
    postmarkMailbox: (organizationId) =>
      rep(ApiRoutes.organization.postmarkMailbox, { organizationId }),
    postmarkMailboxShare: (organizationId) =>
      rep(ApiRoutes.organization.postmarkMailboxShare, { organizationId }),
    postmarkMailboxShareOptions: (organizationId) =>
      rep(ApiRoutes.organization.postmarkMailboxShareOptions, { organizationId }),
    postmarkMailboxVerify: (organizationId) =>
      rep(ApiRoutes.organization.postmarkMailboxVerify, { organizationId }),
    postmarkMailboxTest: (organizationId) =>
      rep(ApiRoutes.organization.postmarkMailboxTest, { organizationId }),
    postmarkInbox: {
      conversations: (organizationId) =>
        rep(ApiRoutes.organization.postmarkInbox.conversations, { organizationId }),
      conversation: (organizationId, conversationId) =>
        rep(ApiRoutes.organization.postmarkInbox.conversation, { organizationId, conversationId }),
      reply: (organizationId, conversationId) =>
        rep(ApiRoutes.organization.postmarkInbox.reply, { organizationId, conversationId }),
      archive: (organizationId, conversationId) =>
        rep(ApiRoutes.organization.postmarkInbox.archive, { organizationId, conversationId }),
      unarchive: (organizationId, conversationId) =>
        rep(ApiRoutes.organization.postmarkInbox.unarchive, { organizationId, conversationId }),
      markRead: (organizationId, conversationId) =>
        rep(ApiRoutes.organization.postmarkInbox.markRead, { organizationId, conversationId }),
      markUnread: (organizationId, conversationId) =>
        rep(ApiRoutes.organization.postmarkInbox.markUnread, { organizationId, conversationId }),
      createDsr: (organizationId, conversationId) =>
        rep(ApiRoutes.organization.postmarkInbox.createDsr, { organizationId, conversationId }),
      bulk: (organizationId) => rep(ApiRoutes.organization.postmarkInbox.bulk, { organizationId }),
      attachment: (organizationId, messageId, attachmentId) =>
        rep(ApiRoutes.organization.postmarkInbox.attachment, {
          organizationId,
          messageId,
          attachmentId,
        }),
    },
    onboardingProgress: (organizationId) =>
      rep(ApiRoutes.organization.onboardingProgress, { organizationId }),
    dataRequestTypes: (organizationId) =>
      rep(ApiRoutes.organization.dataRequestTypes, { organizationId }),
    createChargebeePortal: (organizationId) =>
      rep(ApiRoutes.organization.createChargebeePortal, { organizationId }),
    getChargebeeCustomerInfo: (organizationId) =>
      rep(ApiRoutes.organization.getChargebeeCustomerInfo, { organizationId }),
    features: (organizationId) => rep(ApiRoutes.organization.features, { organizationId }),
    survey: (organizationId, surveyName) =>
      rep(ApiRoutes.organization.survey, { organizationId, surveyName }),
    surveySend: (organizationId, surveyName) =>
      rep(ApiRoutes.organization.surveySend, { organizationId, surveyName }),
    complianceChecklist: (organizationId) =>
      rep(ApiRoutes.organization.complianceChecklist, { organizationId }),
    customMessageType: {
      list: (organizationId) =>
        rep(ApiRoutes.organization.customMessageType.list, { organizationId }),
      specific: (organizationId, slug) =>
        rep(ApiRoutes.organization.customMessageType.specific, { organizationId, slug }),
    },
    childOrgs: (organizationId) => rep(ApiRoutes.organization.childOrgs, { organizationId }),
    messageSettings: (organizationId) =>
      rep(ApiRoutes.organization.messageSettings, { organizationId }),
    customField: (organizationId) => rep(ApiRoutes.organization.customField, { organizationId }),
    customOptOutField: (organizationId) =>
      rep(ApiRoutes.organization.customOptOutField, { organizationId }),
    financialIncentives: (organizationId) =>
      rep(ApiRoutes.organization.financialIncentives, { organizationId }),
    verificationInstruction: (organizationId) =>
      rep(ApiRoutes.organization.verificationInstruction, { organizationId }),
    testMessage: (organizationId) => rep(ApiRoutes.organization.testMessage, { organizationId }),
    privacyCenters: (organizationId) =>
      rep(ApiRoutes.organization.privacyCenters, { organizationId }),
    jwt: (organizationId) => rep(ApiRoutes.organization.jwt, { organizationId }),
    eventPulseLaunch: (organizationId) =>
      rep(ApiRoutes.organization.eventPulseLaunch, { organizationId }),
    mcpTokens: {
      root: (organizationId) => rep(ApiRoutes.organization.mcpTokens.root, { organizationId }),
      specific: (organizationId, tokenId) =>
        rep(ApiRoutes.organization.mcpTokens.specific, { organizationId, tokenId }),
      extend: (organizationId, tokenId) =>
        rep(ApiRoutes.organization.mcpTokens.extend, { organizationId, tokenId }),
    },
    authorization: {
      authorizations: (organizationId) =>
        rep(ApiRoutes.organization.authorization.authorizations, { organizationId }),
      google: (organizationId) =>
        rep(ApiRoutes.organization.authorization.google, { organizationId }),
    },
    processingActivites: {
      root: (organizationId) =>
        rep(ApiRoutes.organization.processingActivities.root, { organizationId }),
      automatic: (organizationId) =>
        rep(ApiRoutes.organization.processingActivities.automatic, { organizationId }),
      specific: (organizationId, id) =>
        rep(ApiRoutes.organization.processingActivities.specific, { organizationId, id }),
      specificAssociationPic: (organizationId, id, picId) =>
        rep(ApiRoutes.organization.processingActivities.specificAssociationPic, {
          organizationId,
          id,
          picId,
        }),
    },
    privacyCenter: {
      verifyDomain: (organizationId, privacyCenterId, domain) =>
        rep(ApiRoutes.organization.privacyCenter.verifyDomain, {
          organizationId,
          privacyCenterId,
          domain,
        }),
      domain: (organizationId, privacyCenterId) =>
        rep(ApiRoutes.organization.privacyCenter.domain, {
          organizationId,
          privacyCenterId,
        }),
      detail: (organizationId, privacyCenterId) =>
        rep(ApiRoutes.organization.privacyCenter.detail, {
          organizationId,
          privacyCenterId,
        }),
      fonts: (organizationId, privacyCenterId) =>
        rep(ApiRoutes.organization.privacyCenter.fonts, {
          organizationId,
          privacyCenterId,
        }),
      deleteImage: (organizationId, privacyCenterId, imageType) =>
        rep(`${ApiRoutes.organization.privacyCenter.deleteImage}?imageType=${imageType}`, {
          organizationId,
          privacyCenterId,
        }),
      privacyPolicy: {
        policy: (organizationId, privacyCenterId) =>
          rep(ApiRoutes.organization.privacyCenter.privacyPolicy.policy, {
            organizationId,
            privacyCenterId,
          }),
        sections: (organizationId, privacyCenterId) =>
          rep(ApiRoutes.organization.privacyCenter.privacyPolicy.sections, {
            organizationId,
            privacyCenterId,
          }),
        section: {
          detail: (organizationId, privacyCenterId, sectionId) =>
            rep(ApiRoutes.organization.privacyCenter.privacyPolicy.sectionDetail, {
              organizationId,
              privacyCenterId,
              sectionId,
            }),
          // Not really needed since it's identical to `sections` but might be helpful somewhere?
          new: (organizationId, privacyCenterId) =>
            rep(ApiRoutes.organization.privacyCenter.privacyPolicy.sections, {
              organizationId,
              privacyCenterId,
            }),
        },
      },
      cmpCustomization: (organizationId, privacyCenterId) =>
        rep(ApiRoutes.organization.privacyCenter.cmpCustomization, {
          organizationId,
          privacyCenterId,
        }),
      cmpCustomizationStaging: (organizationId, privacyCenterId) =>
        rep(ApiRoutes.organization.privacyCenter.cmpCustomizationStaging, {
          organizationId,
          privacyCenterId,
        }),
      updateGAMeasurementId: (organizationId, privacyCenterId) =>
        rep(ApiRoutes.organization.privacyCenter.updateGAMeasurementId, {
          organizationId,
          privacyCenterId,
        }),
      notices: {
        root: (organizationId, privacyCenterId) =>
          rep(ApiRoutes.organization.privacyCenter.notices.root, {
            organizationId,
            privacyCenterId,
          }),
        specific: (organizationId, privacyCenterId, noticeId) =>
          rep(ApiRoutes.organization.privacyCenter.notices.specificNotice, {
            organizationId,
            privacyCenterId,
            noticeId,
          }),
        archiveColoradoEmployeeBiometricNoticePdf: (organizationId, privacyCenterId, noticeId) =>
          rep(
            ApiRoutes.organization.privacyCenter.notices.archiveColoradoEmployeeBiometricNoticePdf,
            {
              organizationId,
              privacyCenterId,
              noticeId,
            },
          ),
        noticeEditorMetadata: (organizationId, privacyCenterId) =>
          rep(ApiRoutes.organization.privacyCenter.notices.noticeEditorMetadata, {
            organizationId,
            privacyCenterId,
          }),
        stateSectionVisibility: (organizationId, privacyCenterId, noticeId) =>
          rep(ApiRoutes.organization.privacyCenter.notices.stateSectionVisibility, {
            organizationId,
            privacyCenterId,
            noticeId,
          }),
        createEditableStateSection: (organizationId, privacyCenterId, noticeId) =>
          rep(ApiRoutes.organization.privacyCenter.notices.createEditableStateSection, {
            organizationId,
            privacyCenterId,
            noticeId,
          }),
        removeEditableStateSection: (organizationId, privacyCenterId, noticeId) =>
          rep(ApiRoutes.organization.privacyCenter.notices.removeEditableStateSection, {
            organizationId,
            privacyCenterId,
            noticeId,
          }),
        downloadStateSectionContent: (organizationId, privacyCenterId, noticeId) =>
          rep(ApiRoutes.organization.privacyCenter.notices.downloadStateSectionContent, {
            organizationId,
            privacyCenterId,
            noticeId,
          }),
        noticePdf: (organizationId, privacyCenterId, noticeId) =>
          rep(ApiRoutes.organization.privacyCenter.notices.noticePdf, {
            organizationId,
            privacyCenterId,
            noticeId,
          }),
        noticeHtml: (organizationId, privacyCenterId, noticeId) =>
          rep(ApiRoutes.organization.privacyCenter.notices.noticeHtml, {
            organizationId,
            privacyCenterId,
            noticeId,
          }),
        redlinesDiff: (organizationId, privacyCenterId) =>
          rep(ApiRoutes.organization.privacyCenter.notices.redlinesDiff, {
            organizationId,
            privacyCenterId,
          }),
        sections: {
          root: (organizationId, privacyCenterId, noticeId) =>
            rep(ApiRoutes.organization.privacyCenter.notices.sections.root, {
              organizationId,
              privacyCenterId,
              noticeId,
            }),
          specific: (organizationId, privacyCenterId, noticeId, sectionId) =>
            rep(ApiRoutes.organization.privacyCenter.notices.sections.specificSection, {
              organizationId,
              privacyCenterId,
              noticeId,
              sectionId,
            }),
        },
      },
      integrations: (organizationId, privacyCenterId) =>
        rep(ApiRoutes.organization.privacyCenter.integrations, {
          organizationId,
          privacyCenterId,
        }),
      availableIntegrationVendorIds: (organizationId, privacyCenterId) =>
        rep(ApiRoutes.organization.privacyCenter.availableIntegrationVendorIds, {
          organizationId,
          privacyCenterId,
        }),
      consentRecords: (organizationId, privacyCenterId) =>
        rep(ApiRoutes.organization.privacyCenter.consentRecords, {
          organizationId,
          privacyCenterId,
        }),
      consentRecordsStats: (organizationId, privacyCenterId) =>
        rep(ApiRoutes.organization.privacyCenter.consentRecordsStats, {
          organizationId,
          privacyCenterId,
        }),
      consentRecordsCsv: (organizationId, privacyCenterId) =>
        `${rep(ApiRoutes.organization.privacyCenter.consentRecords, {
          organizationId,
          privacyCenterId,
        })}/csv`,
      consumerConsentLookup: (organizationId, privacyCenterId) =>
        rep(ApiRoutes.organization.privacyCenter.consumerConsentLookup, {
          organizationId,
          privacyCenterId,
        }),
    },
    requestHandlingInstructions: {
      root: (organizationId) =>
        rep(ApiRoutes.organization.requestHandlingInstructions.root, { organizationId }),
      progress: (organizationId) =>
        rep(ApiRoutes.organization.requestHandlingInstructions.progress, { organizationId }),
      consumerGroup: (organizationId) =>
        rep(ApiRoutes.organization.requestHandlingInstructions.consumerGroup, {
          organizationId,
        }),
      optOut: (organizationId) =>
        rep(ApiRoutes.organization.requestHandlingInstructions.optOut, { organizationId }),
      profilingOptOut: (organizationId) =>
        rep(ApiRoutes.organization.requestHandlingInstructions.profilingOptOut, { organizationId }),
      appeal: (organizationId) =>
        rep(ApiRoutes.organization.requestHandlingInstructions.appeal, { organizationId }),
      correction: (organizationId) =>
        rep(ApiRoutes.organization.requestHandlingInstructions.correction, { organizationId }),
      forType: (organizationId, requestHandlingInstructionType) =>
        rep(ApiRoutes.organization.requestHandlingInstructions.forType, {
          organizationId,
          requestHandlingInstructionType,
        }),
      instruction: (organizationId, requestHandlingInstructionId) =>
        rep(ApiRoutes.organization.requestHandlingInstructions.instruction, {
          organizationId,
          requestHandlingInstructionId,
        }),
    },
    websiteAudit: {
      root: (organizationId) => rep(ApiRoutes.organization.websiteAudit.root, { organizationId }),
      reset: (organizationId) => rep(ApiRoutes.organization.websiteAudit.reset, { organizationId }),
    },
    cookieScanner: {
      root: (organizationId) => rep(ApiRoutes.organization.cookieScanner.root, { organizationId }),
      cookie: (organizationId, domain, name) =>
        rep(ApiRoutes.organization.cookieScanner.cookie, { organizationId, domain, name }),
      cookieRecommendations: (organizationId: OrganizationPublicId) =>
        rep(ApiRoutes.organization.cookieScanner.cookieRecommendations, { organizationId }),
      createCookie: (organizationId: OrganizationPublicId) =>
        rep(ApiRoutes.organization.cookieScanner.createCookie, { organizationId }),
    },
    ramsay: {
      messages: (organizationId: OrganizationPublicId) =>
        rep(ApiRoutes.organization.ramsay.messages, { organizationId }),
      warm: (organizationId: OrganizationPublicId) =>
        rep(ApiRoutes.organization.ramsay.warm, { organizationId }),
      serviceAccountInbox: (organizationId: OrganizationPublicId) =>
        rep(ApiRoutes.organization.ramsay.serviceAccountInbox, { organizationId }),
      serviceAccounts: (organizationId: OrganizationPublicId) =>
        rep(ApiRoutes.organization.ramsay.serviceAccounts, { organizationId }),
    },
    trueScan: {
      root: (organizationId, rebake) =>
        rep(ApiRoutes.organization.trueScan.root, { organizationId, rebake }),
      scan: (organizationId) => rep(ApiRoutes.organization.trueScan.scan, { organizationId }),
      onboardingVendorScan: (organizationId) =>
        rep(ApiRoutes.organization.trueScan.onboardingVendorScan, { organizationId }),
      hasEverScanned: (organizationId) =>
        rep(ApiRoutes.organization.trueScan.hasEverScanned, { organizationId }),
      tracker: (organizationId, trackerId) =>
        rep(ApiRoutes.organization.trueScan.tracker, { organizationId, trackerId }),
      trackerBulkUpdate: (organizationId) =>
        rep(ApiRoutes.organization.trueScan.trackerBulkUpdate, { organizationId }),
      csv: (organizationId, rebake) =>
        `${rep(ApiRoutes.organization.trueScan.csv, { organizationId })}${
          rebake ? "?rebake=true" : ""
        }`,
    },
    cookieConsent: {
      root: (organizationId) => rep(ApiRoutes.organization.cookieConsent.root, { organizationId }),
      csv: (organizationId) =>
        `${rep(ApiRoutes.organization.cookieConsent.root, { organizationId })}.csv`,
    },
    tasks: {
      root: (organizationId) => rep(ApiRoutes.organization.task.root, { organizationId }),
      completeTasks: (organizationId) =>
        rep(ApiRoutes.organization.task.completeTasks, { organizationId }),
      completeTask: (organizationId, taskId) =>
        rep(ApiRoutes.organization.task.completeTask, { organizationId, taskId }),
      addDpo: (organizationId) => rep(ApiRoutes.organization.task.addDpo, { organizationId }),
      addAuthorizeGoogleAnalytics: (organizationId) =>
        rep(ApiRoutes.organization.task.addAuthorizeGoogleAnalytics, { organizationId }),
      completeFinIncentives: (organizationId) =>
        rep(ApiRoutes.organization.task.completeFinIncentives, { organizationId }),
      addEeaDesignatedRep: (organizationId) =>
        rep(ApiRoutes.organization.task.addEeaDesignatedRep, { organizationId }),
    },
    documents: {
      dataProtectionAssessments: {
        root: (organizationId) =>
          rep(ApiRoutes.organization.documents.dataProtectionAssessments.root, { organizationId }),
        suggested: (organizationId) =>
          rep(ApiRoutes.organization.documents.dataProtectionAssessments.suggested, {
            organizationId,
          }),
        specific: (organizationId, dpaId) =>
          rep(ApiRoutes.organization.documents.dataProtectionAssessments.specific, {
            organizationId,
            dpaId,
          }),
        unsignedPdf: (organizationId, dpaId) =>
          rep(ApiRoutes.organization.documents.dataProtectionAssessments.unsignedPdf, {
            organizationId,
            dpaId,
          }),
        signedPdf: (organizationId, dpaId) =>
          rep(ApiRoutes.organization.documents.dataProtectionAssessments.signedPdf, {
            organizationId,
            dpaId,
          }),
        uploadUnsignedPdf: (organizationId, dpaId) =>
          rep(ApiRoutes.organization.documents.dataProtectionAssessments.uploadUnsignedPdf, {
            organizationId,
            dpaId,
          }),
        uploadPreSignedPdf: (organizationId, dpaId) =>
          rep(ApiRoutes.organization.documents.dataProtectionAssessments.uploadPreSignedPdf, {
            organizationId,
            dpaId,
          }),
        prompts: (organizationId) =>
          rep(ApiRoutes.organization.documents.dataProtectionAssessments.prompts, {
            organizationId,
          }),
        abandon: (organizationId, dpaId) =>
          rep(ApiRoutes.organization.documents.dataProtectionAssessments.abandon, {
            organizationId,
            dpaId,
          }),
        answers: {
          root: (organizationId, dpaId) =>
            rep(ApiRoutes.organization.documents.dataProtectionAssessments.answers.root, {
              organizationId,
              dpaId,
            }),
          specific: (organizationId, dpaId, dpaAnswerId) =>
            rep(ApiRoutes.organization.documents.dataProtectionAssessments.answers.specific, {
              organizationId,
              dpaId,
              dpaAnswerId,
            }),
        },
        approvalParties: {
          root: (organizationId, dpaId) =>
            rep(ApiRoutes.organization.documents.dataProtectionAssessments.approvalParties.root, {
              organizationId,
              dpaId,
            }),
          specific: (organizationId, dpaId, dpaApprovalPartyId) =>
            rep(
              ApiRoutes.organization.documents.dataProtectionAssessments.approvalParties.specific,
              {
                organizationId,
                dpaId,
                dpaApprovalPartyId,
              },
            ),
        },
        finalizeSignatures: (organizationId, dpaId) =>
          rep(ApiRoutes.organization.documents.dataProtectionAssessments.finalizeSignatures, {
            organizationId,
            dpaId,
          }),
        cancelSignatureRequest: (organizationId, dpaId) =>
          rep(ApiRoutes.organization.documents.dataProtectionAssessments.cancelSignatureRequest, {
            organizationId,
            dpaId,
          }),
      },
      ropa: {
        root: (organizationId) =>
          rep(ApiRoutes.organization.documents.ropa.root, { organizationId }),
        summary: (organizationId) =>
          rep(ApiRoutes.organization.documents.ropa.summary, {
            organizationId,
          }),
        history: (organizationId) =>
          rep(ApiRoutes.organization.documents.ropa.history, {
            organizationId,
          }),
        delete: (organizationId, ropaId) =>
          rep(ApiRoutes.organization.documents.ropa.delete, {
            organizationId,
            ropaId,
          }),
        download: (organizationId, ropaId) =>
          rep(ApiRoutes.organization.documents.ropa.download, {
            organizationId,
            ropaId,
          }),
        details: (organizationId) =>
          rep(ApiRoutes.organization.documents.ropa.details, {
            organizationId,
          }),
        saveLatestVersion: (organizationId) =>
          rep(ApiRoutes.organization.documents.ropa.saveLatestVersion, {
            organizationId,
          }),
        setMeasures: (organizationId) =>
          rep(ApiRoutes.organization.documents.ropa.setMeasures, {
            organizationId,
          }),
      },
      auditLog: (organizationId: string) =>
        rep(ApiRoutes.organization.documents.auditLog, { organizationId }),
    },
    files: {
      root: (organizationId: OrganizationPublicId) =>
        rep(ApiRoutes.organization.files.root, { organizationId }),
      specific: (organizationId: OrganizationPublicId, fileId: string) =>
        rep(ApiRoutes.organization.files.specific, { organizationId, fileId }),
      download: (organizationId: OrganizationPublicId, fileId: string) =>
        rep(ApiRoutes.organization.files.download, { organizationId, fileId }),
    },
    collectionGroups: {
      root: (organizationId) =>
        rep(ApiRoutes.organization.collectionGroups.root, { organizationId }),
      default: (organizationId) =>
        rep(ApiRoutes.organization.collectionGroups.default, { organizationId }),
      consumer: (organizationId) =>
        rep(ApiRoutes.organization.collectionGroups.consumer, { organizationId }),
      specific: (organizationId, dataSubjectTypeId) =>
        rep(ApiRoutes.organization.collectionGroups.specific, {
          organizationId,
          dataSubjectTypeId,
        }),
      defaultRecipientAssociations: (organizationId, dataSubjectTypeId) =>
        rep(ApiRoutes.organization.collectionGroups.defaultRecipientAssociations, {
          organizationId,
          dataSubjectTypeId,
        }),
      vendor: (organizationId, dataSubjectTypeId, vendorId) =>
        rep(ApiRoutes.organization.collectionGroups.vendor.specific, {
          organizationId,
          dataSubjectTypeId,
          vendorId,
        }),
      mappingProgress: (
        organizationId,
        dataSubjectTypeId,
        personalInformationType,
        mappingProgress,
      ) =>
        rep(ApiRoutes.organization.collectionGroups.mappingProgress, {
          organizationId,
          dataSubjectTypeId,
          personalInformationType,
          mappingProgress,
        }),
      vendorMappingProgress: (organizationId, dataSubjectTypeId) =>
        rep(ApiRoutes.organization.collectionGroups.vendor.mappingProgress, {
          organizationId,
          dataSubjectTypeId,
        }),
      privacyNoticeProgress: (organizationId, dataSubjectTypeId, privacyNoticeProgress) =>
        rep(ApiRoutes.organization.collectionGroups.privacyNoticeProgress, {
          organizationId,
          dataSubjectTypeId,
          privacyNoticeProgress,
        }),
      publishEmployeeGroupHrDataRetentionPolicies: (organizationId) =>
        rep(ApiRoutes.organization.collectionGroups.publishEmployeeGroupHrDataRetentionPolicies, {
          organizationId,
        }),
      getArchivedHrDataRetentionPolicies: (organizationId) =>
        rep(ApiRoutes.organization.collectionGroups.getArchivedHrDataRetentionPolicies, {
          organizationId,
        }),
      downloadArchivedHrDataRetentionPolicyPdf: (organizationId) =>
        rep(ApiRoutes.organization.collectionGroups.downloadArchivedHrDataRetentionPolicyPdf, {
          organizationId,
        }),
    },
    getCompliantDone: (organizationId) =>
      rep(ApiRoutes.organization.getCompliantDone, { organizationId }),
    dataRetention: {
      root: (organizationId) => rep(ApiRoutes.organization.dataRetention.root, { organizationId }),
      automatic: (organizationId) =>
        rep(ApiRoutes.organization.dataRetention.automatic, { organizationId }),
      category: (organizationId, id) =>
        rep(ApiRoutes.organization.dataRetention.category, { organizationId, id }),
    },
    dataMap: {
      root: (organizationId) => rep(ApiRoutes.organization.dataMap.root, { organizationId }),
      picCollection: (organizationId, collectionGroupId, picId) =>
        rep(ApiRoutes.organization.dataMap.picCollection, {
          organizationId,
          collectionGroupId,
          picId,
        }),
      picAssociation: (organizationId, collectionGroupId, vendorId) =>
        rep(ApiRoutes.organization.dataMap.picAssociation, {
          organizationId,
          collectionGroupId,
          vendorId,
        }),
      picSourceAssociation: (organizationId, collectionGroupId, vendorId) =>
        rep(ApiRoutes.organization.dataMap.picSourceAssociation, {
          organizationId,
          collectionGroupId,
          vendorId,
        }),
      picDisclosure: (organizationId, collectionGroupId, vendorId, picGroupId) =>
        rep(ApiRoutes.organization.dataMap.picDisclosure, {
          organizationId,
          collectionGroupId,
          vendorId,
          picGroupId,
        }),
      picReceived: (organizationId, collectionGroupId, vendorId, picGroupId) =>
        rep(ApiRoutes.organization.dataMap.picReceived, {
          organizationId,
          collectionGroupId,
          vendorId,
          picGroupId,
        }),
    },
    dataInventory: {
      snapshot: (organizationId) =>
        rep(ApiRoutes.organization.dataInventory.snapshot, { organizationId }),
      collection: {
        root: (organizationId) =>
          rep(ApiRoutes.organization.dataInventory.collection.root, { organizationId }),
        default: (organizationId) =>
          rep(ApiRoutes.organization.dataInventory.collection.default, {
            organizationId,
          }),
        batch: (organizationId, dataSubjectTypeId) =>
          rep(ApiRoutes.organization.dataInventory.collection.batch, {
            organizationId,
            dataSubjectTypeId,
          }),
        clearInternallyStored: (organizationId, dataSubjectTypeId) =>
          rep(ApiRoutes.organization.dataInventory.collection.clearInternallyStored, {
            organizationId,
            dataSubjectTypeId,
          }),
        specificCategory: (organizationId, dataSubjectTypeId, categoryId) =>
          rep(ApiRoutes.organization.dataInventory.collection.specificCategory, {
            organizationId,
            dataSubjectTypeId,
            categoryId,
          }),
        specificSource: (organizationId, dataSubjectTypeId, sourceId) =>
          rep(ApiRoutes.organization.dataInventory.collection.specificSource, {
            organizationId,
            dataSubjectTypeId,
            sourceId,
          }),
        customSource: (organizationId, dataSubjectTypeId, sourceName) =>
          rep(ApiRoutes.organization.dataInventory.collection.customSource, {
            organizationId,
            dataSubjectTypeId,
            sourceName,
          }),
        specificPurpose: (organizationId, dataSubjectTypeId, purposeId) =>
          rep(ApiRoutes.organization.dataInventory.collection.specificPurpose, {
            organizationId,
            dataSubjectTypeId,
            purposeId,
          }),
      },
      exchange: {
        root: (organizationId) =>
          rep(ApiRoutes.organization.dataInventory.exchange.root, { organizationId }),
        specificConsumerGroup: (organizationId, consumerGroupId) =>
          rep(ApiRoutes.organization.dataInventory.exchange.specificConsumerGroup, {
            organizationId,
            consumerGroupId,
          }),
        specificVendor: (organizationId, vendorId) =>
          rep(ApiRoutes.organization.dataInventory.exchange.specificVendor, {
            organizationId,
            vendorId,
          }),
      },
    },
    dataSources: {
      root: (organizationId) => rep(ApiRoutes.organization.dataSources.root, { organizationId }),
      specific: (organizationId, id) =>
        rep(ApiRoutes.organization.dataSources.specific, { organizationId, id }),
    },
    vendors: {
      root: (organizationId) => rep(ApiRoutes.organization.vendor.root, { organizationId }),
      thirdPartyRecipients: (organizationId) =>
        rep(ApiRoutes.organization.vendor.thirdPartyRecipients, { organizationId }),
      new: (organizationId) => rep(ApiRoutes.organization.vendor.new, { organizationId }),
      search: (organizationId) => rep(ApiRoutes.organization.vendor.search, { organizationId }),
      migrateYotpo: (organizationId) =>
        rep(ApiRoutes.organization.vendor.migrateYotpo, { organizationId }),
      specific: (organizationId, vendorId) =>
        rep(ApiRoutes.organization.vendor.specific, { organizationId, vendorId }),
      add: (organizationId, vendorId) =>
        rep(ApiRoutes.organization.vendor.add, { organizationId, vendorId }),
      edit: (organizationId, vendorId) =>
        rep(ApiRoutes.organization.vendor.edit, { organizationId, vendorId }),
      agreement: (organizationId, vendorId) =>
        rep(ApiRoutes.organization.vendor.agreement, { organizationId, vendorId }),
    },
    privacyNotice: {
      ca: (organizationId) => rep(ApiRoutes.organization.privacyNotice.ca, { organizationId }),
      optOut: (organizationId) =>
        rep(ApiRoutes.organization.privacyNotice.optOut, { organizationId }),
      consumerGroup: (organizationId, consumerGroupId) =>
        rep(ApiRoutes.organization.privacyNotice.consumerGroup, {
          organizationId,
          consumerGroupId,
        }),
    },
    categories: {
      root: (organizationId) => rep(ApiRoutes.organization.categories.root, { organizationId }),
      specific: (organizationId, categoryId) =>
        rep(ApiRoutes.organization.categories.specific, { organizationId, categoryId }),
    },
    managedAdNetworks: {
      root: (organizationId) =>
        rep(ApiRoutes.organization.managedAdNetworks.root, { organizationId }),
      byManager: (organizationId, managerId) =>
        rep(ApiRoutes.organization.managedAdNetworks.byManager, { organizationId, managerId }),
      byNetwork: (organizationId, networkId) =>
        rep(ApiRoutes.organization.managedAdNetworks.byNetwork, { organizationId, networkId }),
      specific: (organizationId, managedAdNetworkId) =>
        rep(ApiRoutes.organization.managedAdNetworks.specific, {
          organizationId,
          managedAdNetworkId,
        }),
      byManagerAndNetwork: (organizationId, managerId, networkId) =>
        rep(ApiRoutes.organization.managedAdNetworks.byManagerAndNetwork, {
          organizationId,
          managerId,
          networkId,
        }),
      dataRetrievedVia: (organizationId) =>
        rep(ApiRoutes.organization.managedAdNetworks.dataRetrievedVia, { organizationId }),
      dataRetrievedViaByNetwork: (organizationId, networkId) =>
        rep(ApiRoutes.organization.managedAdNetworks.dataRetrievedViaByNetwork, {
          organizationId,
          networkId,
        }),
    },
  },
  vendors: {
    specific: (vendorId) => rep(ApiRoutes.vendors.specific, { vendorId }),
  },
  storage: {
    logos: {
      organization: (organizationId) =>
        rep(ApiRoutes.storage.logos.organization, { organizationId }),
      privacyCenter: (organizationId, privacyCenterId) =>
        rep(ApiRoutes.storage.logos.organization, { organizationId, privacyCenterId }),
    },
    fonts: {
      privacyCenter: (organizationId, privacyCenterId) =>
        rep(ApiRoutes.storage.fonts.privacyCenter, { organizationId, privacyCenterId }),
    },
    vendorAgreements: {
      vendor: (organizationId, vendorId) =>
        rep(ApiRoutes.storage.vendorAgreements.root, { organizationId, vendorId }),
      byType: (organizationId, vendorId, type) =>
        rep(ApiRoutes.storage.vendorAgreements.byType, {
          organizationId,
          vendorId,
          type,
        }),
      specific: (organizationId, vendorId, fileKey) =>
        rep(ApiRoutes.storage.vendorAgreements.specific, {
          organizationId,
          vendorId,
          fileKey,
        }),
    },
  },

  consumer: {
    requests: (organizationId) => rep(ApiRoutes.organization.consumer.requests, { organizationId }),
    export: (organizationId) => rep(ApiRoutes.organization.consumer.export, { organizationId }),
  },

  organizationRequests: (organizationId) =>
    rep(ApiRoutes.organization.request.root, { organizationId }),

  organizationGpcOptOuts: (organizationId) =>
    rep(ApiRoutes.organization.request.gpcOptOuts, { organizationId }),

  organizationGpcOptOutsCsv: (organizationId) =>
    rep(ApiRoutes.organization.request.gpcOptOutsCsv, { organizationId }),

  organizationRequestsCsv: (organizationId) =>
    `${rep(ApiRoutes.organization.request.root, { organizationId })}.csv`,

  organizationRequestStats: (organizationId) =>
    rep(ApiRoutes.organization.request.stats, { organizationId }),

  organizationRequest: (organizationId, requestId) =>
    rep(ApiRoutes.organization.request.specific, { organizationId, requestId }),

  organizationRequestExtend: (organizationId, requestId) =>
    rep(ApiRoutes.organization.request.extend, { organizationId, requestId }),

  organizationRequestClosedTemplate: (organizationId, requestId) =>
    rep(ApiRoutes.organization.request.templates.closed, { organizationId, requestId }),

  organizationRequestContactVendorsMessageTemplate: (organizationId, requestId) =>
    rep(ApiRoutes.organization.request.templates.contactVendor, { organizationId, requestId }),

  organizationRequestContactVendorsPreviewMessage: (organizationId, requestType) =>
    rep(ApiRoutes.organization.request.templates.contactVendorPreview, {
      organizationId,
      type: requestType,
    }),

  organizationRequestState: (organizationId, requestId) =>
    rep(ApiRoutes.organization.request.state, { organizationId, requestId }),

  organizationRequestVerify: (organizationId, requestId) =>
    rep(ApiRoutes.organization.request.verify, { organizationId, requestId }),

  organizationRequestAutodeleteGoogleAnalytics: (organizationId, requestId) =>
    rep(ApiRoutes.organization.request.autodelete.googleAnalytics, { organizationId, requestId }),

  organizationRequestVendor: (organizationId, requestId) =>
    rep(ApiRoutes.organization.request.vendor, { organizationId, requestId }),

  organizationRequestContactVendors: (organizationId, requestId) =>
    rep(ApiRoutes.organization.request.contactVendors, { organizationId, requestId }),

  organizationRequestContactRequestor: (organizationId, requestId) =>
    rep(ApiRoutes.organization.request.contactRequestor, { organizationId, requestId }),

  organizationRequestNote: (organizationId, requestId) =>
    rep(ApiRoutes.organization.request.note, { organizationId, requestId }),

  organizationRequestReply: (organizationId, requestId) =>
    rep(ApiRoutes.organization.request.reply, { organizationId, requestId }),

  organizationRequestReopen: (organizationId, requestId) =>
    rep(ApiRoutes.organization.request.reopen, { organizationId, requestId }),

  organizationRequestStepConsumerGroup: (organizationId, requestId) =>
    rep(ApiRoutes.organization.request.stepConsumerGroup, { organizationId, requestId }),

  organizationRequestSetSubjectStatus: (organizationId, requestId) =>
    rep(ApiRoutes.organization.request.setSubjectStatus, { organizationId, requestId }),

  organizationRequestStepForward: (organizationId, requestId) =>
    rep(ApiRoutes.organization.request.stepForward, { organizationId, requestId }),

  organizationRequestStepBack: (organizationId, requestId) =>
    rep(ApiRoutes.organization.request.stepBack, { organizationId, requestId }),

  organizationRequestManuallyAutomate: (organizationId, requestId) =>
    rep(ApiRoutes.organization.request.manuallyAutomate, { organizationId, requestId }),

  organizationRequestAttachments: (organizationId, requestId) =>
    rep(ApiRoutes.organization.request.dataRequestAttachments, { organizationId, requestId }),

  organizationRequestAttachment: (organizationId, requestId, attachmentId) =>
    rep(ApiRoutes.organization.request.dataRequestAttachmentSpecific, {
      organizationId,
      requestId,
      attachmentId,
    }),

  organizationRequestBatches: (organizationId) =>
    rep(ApiRoutes.organization.requestBatch.root, { organizationId }),

  organizationRequestBatch: (organizationId, batchId) =>
    rep(ApiRoutes.organization.requestBatch.specific, { organizationId, batchId }),

  organizationRequestBatchCreate: (organizationId) =>
    rep(ApiRoutes.organization.requestBatch.create, { organizationId }),

  organizationRequestBatchDelete: (organizationId) =>
    rep(ApiRoutes.organization.requestBatch.delete, { organizationId }),

  organizationExports: (organizationId) =>
    rep(ApiRoutes.organization.exports.root, { organizationId }),

  organizationExport: (organizationId, jobId) =>
    rep(ApiRoutes.organization.exports.specific, { organizationId, jobId }),

  organizationDataRecipients: (organizationId) =>
    rep(ApiRoutes.organization.dataRecipients.root, { organizationId }),

  organizationDataRecipient: (organizationId, vendorId) =>
    rep(ApiRoutes.organization.dataRecipients.specific, { organizationId, vendorId }),

  organizationVendors: (organizationId) =>
    rep(ApiRoutes.organization.vendor.root, { organizationId }),

  organizationUnmappedVendors: (organizationId, collectionGroupId) =>
    rep(ApiRoutes.organization.vendor.unmapped, { organizationId, collectionGroupId }),

  organizationRemoveVendors: (organizationId) =>
    rep(ApiRoutes.organization.vendor.remove, { organizationId }),

  organizationVendorsDefault: (organizationId) =>
    rep(ApiRoutes.organization.vendor.default, { organizationId }),

  organizationVendor: (organizationId, vendorId) =>
    rep(ApiRoutes.organization.vendor.specific, { organizationId, vendorId }),

  organizationVendorAgreement: (organizationId, vendorId) =>
    rep(ApiRoutes.organization.vendor.agreement, { organizationId, vendorId }),

  organizationVendorAutomationHistory: (organizationId) =>
    rep(ApiRoutes.organization.vendor.automationHistory, { organizationId }),

  organizationPlatformApps: (organizationId, vendorId) =>
    rep(ApiRoutes.organization.vendor.platformApps, { organizationId, vendorId }),

  organizationPlatformAppsByVendorKey: (organizationId, vendorKey) =>
    rep(ApiRoutes.organization.vendor.platformAppsByVendorKey, { organizationId, vendorKey }),

  organizationAppPlatforms: (organizationId, vendorId) =>
    rep(ApiRoutes.organization.vendor.appPlatforms, { organizationId, vendorId }),

  organizationPlatformInstall: (organizationId, platformId, appId) =>
    rep(ApiRoutes.organization.vendor.appInstall, { organizationId, platformId, appId }),

  organizationVendorCommonCatalog: (organizationId) =>
    rep(ApiRoutes.organization.vendor.commonCatalog, { organizationId }),

  organizationVendorCustomCatalog: (organizationId) =>
    rep(ApiRoutes.organization.vendor.customCatalog, { organizationId }),

  organizationVendorMappingProgress: (organizationId, vendorId, mappingProgress) =>
    rep(ApiRoutes.organization.vendor.mappingProgress, {
      organizationId,
      vendorId,
      mappingProgress,
    }),

  organizationAdminUsers: (organizationId) =>
    rep(ApiRoutes.organization.admin.users, { organizationId }),

  organizationAdminSpecificUser: (organizationId, email) =>
    rep(ApiRoutes.organization.admin.specificUser, { organizationId, email }),

  organizationAdminAssignUserRole: (organizationId, email) =>
    rep(ApiRoutes.organization.admin.assignUserRole, { organizationId, email }),

  organizationAdminActivateUser: (organizationId, email) =>
    rep(ApiRoutes.organization.admin.activateUser, { organizationId, email }),

  organizationAdminDeactivateUser: (organizationId, email) =>
    rep(ApiRoutes.organization.admin.deactivateUser, { organizationId, email }),

  organizationAdminInviteUser: (organizationId) =>
    rep(ApiRoutes.organization.admin.inviteUser, { organizationId }),

  organizationVendorRequestDocumentation: (organizationId) =>
    rep(ApiRoutes.organization.vendor.requestDocumentation, { organizationId }),

  organizationRequestVendorDocumentationBulk: (organizationId) =>
    rep(ApiRoutes.organization.vendor.requestVendorDocumentationBulk, { organizationId }),

  organizationRequestVendorServiceProviderInfo: (organizationId) =>
    rep(ApiRoutes.organization.vendor.requestVendorServiceProviderInfo, { organizationId }),

  organizationRequestGdprProcessorStatusInfo: (organizationId) =>
    rep(ApiRoutes.organization.vendor.requestGdprProcessorStatusInfo, { organizationId }),
};
